// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { ClerkProvider } from "@clerk/clerk-react";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";

const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

if (!clerkPubKey) {
  console.error(
    "❌ Missing Clerk Publishable Key. Set REACT_APP_CLERK_PUBLISHABLE_KEY in frontend .env"
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ClerkProvider publishableKey={clerkPubKey} appearance={{ cssLayerName: "clerk" }}>
      <BrowserRouter basename="/">
        <App />
      </BrowserRouter>
    </ClerkProvider>
  </React.StrictMode>
);
